import {
  styled,
  Button,
  buttonClasses,
  Menu,
  menuClasses,
  MenuItem,
  TextField,
  inputLabelClasses,
  selectClasses,
  inputBaseClasses,
  autocompleteClasses,
} from '@mui/material';
import { AccessFeature } from '~components/index';

import PlacesAutocomplete from '~components/PlacesAutocomplete';
import CustomersAutocomplete from '~components/CustomersAutocomplete';
import { CustomersAutocompleteProps } from '~components/CustomersAutocomplete/types';

export const PointAddressSelectorFieldSet = styled('fieldset', {
  shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
  position: 'relative',
  border: '1px solid rgba(0, 0, 0, 0.23)',
  borderRadius: theme.shape.borderRadius,
  paddingTop: 0,
  paddingLeft: 12,
  paddingRight: 0,
  paddingBottom: 0,
  color: theme.palette.text.secondary,
  display: 'flex',
  gap: theme.spacing(1),
  width: '100%',
  alignItems: 'center',

  ...(error && {
    border: `1px solid ${theme.palette.error.main}`,
  }),
}));

export const PointAddressSelectorMenuButton = styled(Button)(({ theme }) => ({
  minWidth: 40,
  padding: 0,
  margin: 0,
  border: 0,
  justifyContent: 'space-around',
  fontSize: theme.typography.pxToRem(17),
  gap: 4,
  color: theme.palette.action.active,

  '&:hover': {
    backgroundColor: 'transparent',
    border: 0,
  },

  [`& .${buttonClasses.endIcon}`]: {
    margin: 0,
  },
}));

export const PointAddressSelectorMenuContainer = styled(Menu)({
  [`& .${menuClasses.paper}`]: {
    border: '1px solid #d3d4d5',
  },
});

export const PointAddressSelectorMenuItemContainer = styled(MenuItem)({
  whiteSpace: 'pre-wrap',
});

export const PointAddressSelectorMenuItemAccessFeatureContainer = styled(
  AccessFeature.MenuItem,
)({ whiteSpace: 'pre-wrap' });

export const PointAddressSelectorSelectField = styled(TextField)({
  [`& .${inputLabelClasses.root}`]: {
    transform: 'translate(0px, 13px) scale(1)',

    '&[data-shrink="true"]': {
      transform: 'translate(0px, 4px) scale(0.75)',
    },
  },

  [`& .${selectClasses.select}`]: {
    border: 0,
    paddingLeft: 0,
    paddingTop: 19,
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 0,
    padding: 0,
  },
});

export const PointAddressSelectorCustomersAutocompleteField = styled(
  (props: CustomersAutocompleteProps<false, false, false>) => (
    <CustomersAutocomplete {...props} />
  ),
)({
  [`& .${inputLabelClasses.root}`]: {
    transform: 'translate(0px, 13px) scale(1)',

    '&[data-shrink="true"]': {
      transform: 'translate(0px, 4px) scale(0.75)',
    },
  },

  [`& .${inputBaseClasses.root}.${autocompleteClasses.inputRoot}`]: {
    border: 0,
    paddingLeft: 0,
    paddingTop: 19,
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 0,
    padding: 0,
  },
});

export const PointAddressSelectorPlacesAutocompleteField = styled(
  PlacesAutocomplete,
)({
  [`& .${inputLabelClasses.root}`]: {
    transform: 'translate(0px, 13px) scale(1)',

    '&[data-shrink="true"]': {
      transform: 'translate(0px, 4px) scale(0.75)',
    },
  },

  [`& .${inputBaseClasses.root}.${autocompleteClasses.inputRoot}`]: {
    border: 0,
    paddingLeft: 0,
    paddingTop: 19,
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 0,
    padding: 0,
  },
});
